"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkoutMinProperties = exports.ExerciseGroupType = exports.SatisfactionLevel = void 0;
var SatisfactionLevel;
(function (SatisfactionLevel) {
    SatisfactionLevel[SatisfactionLevel["AWESOME"] = 0] = "AWESOME";
    SatisfactionLevel[SatisfactionLevel["OK"] = 1] = "OK";
    SatisfactionLevel[SatisfactionLevel["POOR"] = 2] = "POOR";
})(SatisfactionLevel = exports.SatisfactionLevel || (exports.SatisfactionLevel = {}));
var ExerciseGroupType;
(function (ExerciseGroupType) {
    ExerciseGroupType["WARMUP"] = "WARMUP";
    ExerciseGroupType["COOLDOWN"] = "COOLDOWN";
    ExerciseGroupType["WORKOUT"] = "WORKOUT";
})(ExerciseGroupType = exports.ExerciseGroupType || (exports.ExerciseGroupType = {}));
// we will use this array just to pick those fields from object
exports.WorkoutMinProperties = ["title", "thumbnailURL"];
//# sourceMappingURL=Workout.js.map